import React from 'react';
import PropTypes from 'prop-types';
import Link from '@nubank/nuds-web/components/Link/Link';

import Spacer from 'components/structure/Spacer';

function BlockHeading({ children, href }) {
  return (
    <>
      <Link
        href={href}
        typographyProps={{
          variant: 'subtitle',
        }}
      >
        {children}
      </Link>
      <Spacer multiplier={4} />
    </>
  );
}

BlockHeading.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
};

export default React.memo(BlockHeading);
